import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, createTransform } from "redux-persist";
import AccountProfileReducer from "./ApiSlice/AccountProfileSlice";
import HomepageVideoReducer from "./ApiSlice/HomePageVideoSlice";
import UploadvideoReducer from "./ApiSlice/UploadVideoSlice";
import lostPasswordReducer from "./ApiSlice/LostPasswordSlice";
import SearchReducer from "./ApiSlice/SearchSlice";
import HashTagReducer from "./ApiSlice/HashTagSlice";
import SavedVideoReducer from "./ApiSlice/SavedVideosSlice";
import UserStatusReducer from "./ApiSlice/UserStatusSlice";
import WatchVideoReducer from "./ApiSlice/WatchVideoSlice";
import MessagesReducer from "./ApiSlice/MessagesSlice";
import MessageGroupReducer from "./ApiSlice/MessageGroupSlice";
import NotificationReducer from "./ApiSlice/NotificationSlice";
import AccountPrivateReducer from "./ApiSlice/AccountPrivateSlice";
import { setUploadProgress } from "./ApiSlice/UploadVideoSlice";
import CommentsReducer from "./ApiSlice/CommentsSlice";
import GroupReducer from "./ApiSlice/Group/GroupSlice";
import GroupPostReducer from "./ApiSlice/Group/GroupPostsSlice";
import GroupMemberReducer from "./ApiSlice/Group/GroupMembersSlice";
import GroupModeratorsReducer from "./ApiSlice/Group/GroupModeratorsSlice";
import GroupPostReportReducer from "./ApiSlice/Group/GroupPostReportSlice";
import GroupSavedReducer from "./ApiSlice/Group/GroupPostSaveSlice";
import GroupSearchReducer from "./ApiSlice/Group/GroupSearchSlice";
import ContactUsReducer from "./ApiSlice/ContactUs";
import GroupReportReducer from "./ApiSlice/Group/GroupReport";
import GroupHideReducer from "./ApiSlice/Group/GroupPostHide";
import GroupPostCommentsSlice from "./ApiSlice/Group/GroupPostCommentsSlice";
import GroupChatRoomReducer from "./ApiSlice/Group/GroupChatRoomSlice";
import userLikedPostsReducer from "./ApiSlice/LikedVideosSlice";
import RecommendationReducer from "./ApiSlice/RecommendationSlice";
import LocationReducer from "./ApiSlice/LocationSlice";
import NeighborhoodReducer from "./ApiSlice/Neighborhood/NeighborhoodSlice";
import NeighborhoodNewsReducer from "./ApiSlice/Neighborhood/NeighborhoodNewsSlice";
import NeighborhoodPinboardSlice from "./ApiSlice/Neighborhood/NeighborhoodPinboardSlice";
import NeighborhoodNewsCommentReducer from "./ApiSlice/Neighborhood/NeighBorhoodNewsCommentSlice";
import NeighborhoodNewsSavedReducer from "./ApiSlice/Neighborhood/NeighBorhoodNewsSavedSlice";
import NeighborhoodNewsReportReducer from "./ApiSlice/Neighborhood/NeighborhoodNewsReportSlice";
import NeighborhoodInviteReducer from "./ApiSlice/Neighborhood/InviteNeighborhoodSlice";
import NeighborInviteSearchReducer from "./ApiSlice/Neighborhood/NeighborInviteSearchSlice";
import NeighborhoodCommunityChatReducer from "./ApiSlice/Neighborhood/NeighborhoodCommunityChatSlice";
import SwitchAccountReducer from "./ApiSlice/SwitchAccountSlice";
import NeighborhoodPinboardCommentReducer from "./ApiSlice/Neighborhood/NeighborhoodPinboardCommentSlice";
import ShareReducer from "./ApiSlice/ShareSlice";
import DraftReducer from "./ApiSlice/DraftSlice";
import HelpReducer from "./ApiSlice/HelpSlice";
import BlockReducer from "./ApiSlice/BlockSlice";
import SignupReducer from "./ApiSlice/Auth/SignupSlice";
import ReSharedListReaducer from "./ApiSlice/ResharedSlice";
import MutualFriendsReducer from "./ApiSlice/MutualFriendsSlice";
import LiveStreamReducer from "./ApiSlice/LiveStreamSlice";
import ReportReducer from "./ApiSlice/ReportSlice";
import ActivityReducer from "./ApiSlice/ActivitySlice";
import AccountReducer from "./ApiSlice/AccountSettingSlice";
import LogoutReducer from "./ApiSlice/LogoutSlice";
import authReducer from "./ApiSlice/Auth/AuthSlice";
import WaitlistReducer from "./ApiSlice/WaitlistSlice";
import WaitlistCountReducer from "./ApiSlice/WaitlistCountSlice";
import FeedBackReducer from "./ApiSlice/FeedBackSlice";
import CategoryReducer from "./ApiSlice/CategorySlice";
import ReportCenterReducer from "./ApiSlice/ReportCenterSlice";
import DataExportReducer from "./ApiSlice/DataExportSlice";
import ParentalControlReducer from "./ApiSlice/ParentalControlSlice";
import VideoPreferencesReducer from "./ApiSlice/VideoPreferencesSlice";

const rootReducer = combineReducers({
    auth: authReducer,
    SignUp: SignupReducer,
    AccountProfile: AccountProfileReducer,
    switchAccount: SwitchAccountReducer,
    SearchItems: SearchReducer,
    HomePageVideo: HomepageVideoReducer,
    Uploadvideo: UploadvideoReducer,
    lostPassword: lostPasswordReducer,
    HashTag: HashTagReducer,
    savedVideos: SavedVideoReducer,
    UserPrivate_Status: UserStatusReducer,
    WatchVideo: WatchVideoReducer,
    messages: MessagesReducer,
    messageGroup: MessageGroupReducer,
    Notification: NotificationReducer,
    AccountPrivate: AccountPrivateReducer,
    ProgressBar: setUploadProgress,
    comments: CommentsReducer,
    group: GroupReducer,
    groupPosts: GroupPostReducer,
    groupMembers: GroupMemberReducer,
    groupModerators: GroupModeratorsReducer,
    groupPostReport: GroupPostReportReducer,
    groupSavedPosts: GroupSavedReducer,
    groupSearch: GroupSearchReducer,
    groupChatRoom: GroupChatRoomReducer,
    GroupReport: GroupReportReducer,
    contactUs: ContactUsReducer,
    GroupHiddenPosts: GroupHideReducer,
    groupPostComments: GroupPostCommentsSlice,
    userLikedPosts: userLikedPostsReducer,
    recommendationUser: RecommendationReducer,
    resharedPosts: ReSharedListReaducer,
    LocationAddress: LocationReducer,
    Neighborhood: NeighborhoodReducer,
    NeighborhoodNews: NeighborhoodNewsReducer,
    NeighborhoodPinboard: NeighborhoodPinboardSlice,
    NeighborhoodPinboardComment: NeighborhoodPinboardCommentReducer,
    NeighborhoodNewsComment: NeighborhoodNewsCommentReducer,
    NeighborhoodSavedNews: NeighborhoodNewsSavedReducer,
    NeighborhoodReportNews: NeighborhoodNewsReportReducer,
    NeighborhoodInvite: NeighborhoodInviteReducer,
    NeighborInviteSearch: NeighborInviteSearchReducer,
    NeighborhoodCommunityChat: NeighborhoodCommunityChatReducer,
    SharePost: ShareReducer,
    draft: DraftReducer,
    help: HelpReducer,
    blockedUsers: BlockReducer,
    mutualFriends: MutualFriendsReducer,
    liveStream: LiveStreamReducer,
    Report: ReportReducer,
    YourActivity: ActivityReducer,
    AccountSetting: AccountReducer,
    Logout: LogoutReducer,
    waitlist: WaitlistReducer,
    waitlistCount: WaitlistCountReducer,
    feedback: FeedBackReducer,
    Category: CategoryReducer,
    ReportCenter: ReportCenterReducer,
    DataExport: DataExportReducer,
    ParentalControl: ParentalControlReducer,
    VideoPreferences: VideoPreferencesReducer,
});

// Custom transform to persist only videoData from HomePageVideo
const HomePageVideoTransform = createTransform(
    // Transform state on its way to being serialized and persisted
    (inboundState, key) => {
        if (key === 'HomePageVideo') {
            // Only persist videoData
            return {
                videoData: inboundState.videoData || []
            };
        }
        return inboundState;
    },
    // Transform state being rehydrated
    (outboundState, key) => {
        if (key === 'HomePageVideo') {
            // Merge persisted videoData with initial state
            return {
                AllPosts: [],
                videoData: outboundState.videoData || [],
                homePageVideos: [],
                postCommants: [],
                currentIndex: 0,
                pageNumber: 1,
                next: null,
                loading: false,
                error: null,
            };
        }
        return outboundState;
    },
    // Define which reducers this transform gets called for
    { whitelist: ['HomePageVideo'] }
);

// Transform to persist only pendingUploads from Uploadvideo — moderation
// review can take longer than a browser session, so this must survive a
// refresh/app restart or a rejection popup can never fire.
const UploadvideoTransform = createTransform(
    (inboundState, key) => {
        if (key === 'Uploadvideo') {
            return { pendingUploads: inboundState.pendingUploads || {} };
        }
        return inboundState;
    },
    (outboundState, key) => {
        if (key === 'Uploadvideo') {
            return {
                SelectedVideo: {},
                loading: false,
                error: null,
                progress: 0,
                uploadId: null,
                s3Key: "",
                pendingUploads: outboundState.pendingUploads || {},
            };
        }
        return outboundState;
    },
    { whitelist: ['Uploadvideo'] }
);

// List of reducers to persist
const reducersToPersist = ["AccountProfile", "SignUp", "AccountPrivate", "HomePageVideo", "Uploadvideo", "VideoPreferences"];

// Persist configuration
const persistConfig = {
    key: "root",
    storage,
    whitelist: reducersToPersist, // Add the reducers you want to persist
    transforms: [HomePageVideoTransform, UploadvideoTransform], // Apply custom transforms
};


// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
const immutableIgnoredPaths = [
    "HomePageVideo.homePageVideos",
    "HomePageVideo.videoData",
    "HomePageVideo.AllPosts",
];

const immutableCheckConfig =
    process.env.NODE_ENV === "production"
        ? false
        : {
            warnAfter: 64,
            ignoredPaths: immutableIgnoredPaths,
        };

// Enhanced middleware to completely block extension actions
const blockExtensionActionsMiddleware = (store) => (next) => (action) => {
    // Completely block browser extension actions
    if (action && action.type && typeof action.type === 'string') {
        const blockedPatterns = [
            'suiteux-extensibility',
            'SET_BADGE_COLOR',
            'chrome-extension',
            'moz-extension',
            'webkit-masked-url',
            'EXTENSION_',
            '@@extension',
            'content-script',
            'background-script'
        ];

        const isBlocked = blockedPatterns.some(pattern =>
            action.type.toLowerCase().includes(pattern.toLowerCase())
        );

        if (isBlocked) {
            // Completely ignore extension actions - don't pass to next middleware
            return;
        }
    }

    return next(action);
};

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
            immutableCheck: immutableCheckConfig,
        }).concat(blockExtensionActionsMiddleware),
    devTools: process.env.NODE_ENV !== 'production' && {
        // Completely prevent extension actions from appearing in DevTools
        predicate: (state, action) => {
            if (action && action.type && typeof action.type === 'string') {
                const blockedPatterns = [
                    'suiteux-extensibility',
                    'SET_BADGE_COLOR',
                    'chrome-extension',
                    'moz-extension',
                    'webkit-masked-url'
                ];

                const isBlocked = blockedPatterns.some(pattern =>
                    action.type.toLowerCase().includes(pattern.toLowerCase())
                );

                // Return false to completely hide from DevTools
                return !isBlocked;
            }
            return true;
        },
        maxAge: 25, // Reduce history to improve performance
        trace: false, // Disable tracing for better performance
        actionsDenylist: [
            'suiteux-extensibility.SET_BADGE_COLOR',
            'SET_BADGE_COLOR'
        ]
    }
});

export const persistor = persistStore(store);